/**
 * Social-login buttons (Google / X / Instagram). The Google variant
 * follows Google's "Sign in with Google" styling (white surface, dark
 * ink, official 4-color G); X gets the canonical black-on-white pill
 * with its monogram; Instagram uses its gradient camera. Each button is
 * a plain anchor to the auth service's OAuth login endpoint — the
 * service handles the redirect-and-callback flow and lands the parent
 * back on /auth/callback with an access token in the fragment.
 */
import { Button } from '@/components/ui/button';
import { oauthLoginUrl } from '@/api/auth';
import { GoogleIcon } from '@/components/BrandIcons';

type Provider = 'google' | 'x' | 'instagram';

const PROVIDERS: Array<{
  key: Provider;
  label: string;
  Icon: typeof GoogleIcon;
  className: string;
}> = [
  {
    key: 'google',
    label: 'Continue with Google',
    Icon: GoogleIcon,
    className:
      'bg-white text-[#1f1f1f] border-[#dadce0] hover:bg-[#f6f6f6] hover:border-[#d2d2d2]',
  },
];

export function OAuthButtons() {
  return (
    <div className="grid gap-2">
      {PROVIDERS.map(({ key, label, Icon, className }) => (
        <Button
          key={key}
          asChild
          variant="outline"
          size="lg"
          className={`w-full justify-center border font-medium [&_svg]:size-5 ${className}`}
        >
          <a href={oauthLoginUrl(key)} aria-label={label}>
            <Icon />
            <span>{label}</span>
          </a>
        </Button>
      ))}
    </div>
  );
}
